import reactComponentLoader from 'scripts/react-component-loader'

import Spinner from '../Spinner'

reactComponentLoader(Spinner, '[data-spinner-component]')
